/**
 * Getting information about app version and available updates waiting to install
 */
import buildInfo from "../config/buildInfo.json";
import store from "../config/configureStore";
import moment from "moment";
import { getService } from "./service";
import { handleError } from "./ErrorReducer";
import { serviceNames } from "../utils/constants";

const GET_APP_VERSION = "APPINFO/GET_APP_VERSION";
const GET_API_VERSION = "APPINFO/GET_API_VERSION";
const GET_VERSION_VALIDATION = "APPINFO/GET_VERSION_VALIDATION";
const CHECK_FOR_UPDATES = "APPINFO/CHECK_FOR_UPDATES";
let basename = window.__RUNTIME_CONFIG__.REACT_APP_BASENAME
  ? window.__RUNTIME_CONFIG__.REACT_APP_BASENAME
  : "/";

const abbBuildTime = moment(buildInfo.time).isValid()
  ? timeStrFromTimestamp(buildInfo.time)
  : "?";

const defaultState = {
  apiAmsVersion: "",
  compilationNo: buildInfo.compilation,
  buildNo: buildInfo.build,
  buildTime: abbBuildTime,
  availBuildNo: "",
  availBuildTime: "",
  apiVersion: "",
  appVersion: "",
  registration: null,
  appVersionInfo: null,
};

export const updateApp = (registration) => {
  const waitingServiceWorker = registration.waiting;

  if (waitingServiceWorker) {
    waitingServiceWorker.addEventListener("statechange", (event) => {
      if (event.target.state === "activated") {
        window.location.reload();
      }
    });
    waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
  }
};

// ======================= ACTIONS =======================
/** Get  API Version - must be implemented on api side */
export const getApiVer = () => {
  return async (dispatch) => {
    try {
      const service = getService("version");
      service.timeout = 20000;
      const data = await service.get(null, { query: { appName: 'AMS' } });
      dispatch({ type: GET_API_VERSION, payload: data.ver });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const verifyAppVersion = () => {
  return async (dispatch) => {
      try {
        const service = getService(serviceNames.CDR);
        const data = await service.find({ query: { Path: 'Version.Validation', CDRKey: 'APP_VERSION' } });
        const appValidation = JSON.parse(data?.[0]?.ValueJson)?.["AMS"] || null;
        dispatch({ type: GET_VERSION_VALIDATION, payload: appValidation });
      } catch (error) {
        dispatch(handleError(error));
      }
  };
};

export const getAppVersion = () => {
  return async (dispatch) => {
    try {
      const result = await checkForNewVersion(true);
      dispatch({ type: GET_APP_VERSION, payload: result?.appVer });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const checkForUpdates = () => {
  return async (dispatch) => {
    try {
      const result = await checkForNewVersion();
      dispatch({ type: CHECK_FOR_UPDATES, payload: result });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const updateIfNewVersionAvail = () => {
  const appInfo = store.store.getState().appInfo;
  return async (dispatch) => {
    try {
      const result = await checkForNewVersion();
      const buildTime = timeStrFromTimestamp(result.time);
      if (appInfo.buildNo !== result.build || appInfo.buildTime !== buildTime) {
        window.location.reload(true);
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

// ======================= REDUCER =======================
export default function reducer(state = defaultState, action) {
  let time, build, buildTime, appVersion;
  switch (action.type) {
    case GET_API_VERSION:
      return { ...state, apiVersion: action.payload };
    case GET_APP_VERSION:
      return { ...state, appVersion: action.payload };
    case GET_VERSION_VALIDATION:
      return { ...state, appVersionInfo: action.payload };
    case CHECK_FOR_UPDATES:
      time = action.payload.time;
      build = action.payload.build;
      appVersion = action.payload.appVer;
      if (moment(time).isValid()) {
        buildTime = timeStrFromTimestamp(time);
      } else {
        buildTime = state.availBuildTime;
      }
      return {
        ...state,
        availBuildNo: build,
        availBuildTime: buildTime,
        appVersion,
      };
    default:
      return state;
  }
}

// ======================= HELPER FUNCTIONS =======================

export function checkForNewVersion(isCurrent = false) {
  return new Promise((resolve, reject) => {
    fetch(`${basename}buildInfo.json${isCurrent ? `` :`?ver=${new Date().getTime()}`}`)
      .then((response) => {
        if (response.ok) {
          resolve(response.json());
        } else {
          reject("Cannot get updates information #1");
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function timeStrFromTimestamp(timestamp) {
  return moment(timestamp).format("MM/DD/YYYY HH:mm:ss");
}
